export class Notification {
    id!: string
    title!: string
    body!: string
    richBody!: string
    icon!: string
    action!: string
    notes!: string
    scheduledDate!: Date | undefined
    expiresOn!: Date | undefined

    groupIds!: string[]
}
